import {useIntl} from 'react-intl';
import * as React from 'react';
import {useEffect, useRef} from 'react';
import useSWR from "swr";
import {UnprocessedBankTransactionResponse} from "../../../../lib/types/types";
import TransactionDetailsRow from "../../TransactionDetailsRow";
import CreateAdvancePayment from "../../../invoices/advancePayments/CreateAdvancePayment";

interface Props {
    transactionId?: number;
    onClose(): void;
}

const CreateAdvancePayments: React.FC<Props> = props => {
    const {formatMessage: f} = useIntl();
    const didMountRef = useRef(false);

    const selectedTransactionMutationKey = `/bank/transactions/${props.transactionId}`;
    const {data: selectedTransaction} = useSWR<UnprocessedBankTransactionResponse>(props.transactionId ? selectedTransactionMutationKey : null);

    useEffect(() => {
        if (!didMountRef.current) {
            didMountRef.current = true;
        }
    }, []);

    return <>
        {selectedTransaction &&
            <>
                <TransactionDetailsRow selectedTransaction={selectedTransaction}/>
                <CreateAdvancePayment bankTransaction={selectedTransaction} onSave={props.onClose}/>
            </>
        }
    </>
};

export default CreateAdvancePayments
